import { Button, Dialog, Stack, Typography } from "@mui/material"
import { ProposedTimeSlot } from "../../../types"
import { useMemo, useState } from "react"
import { DateTimePicker } from "@mui/x-date-pickers"

interface MeetingTimeSelectionModalProps {
    open: boolean
    existingSlot: ProposedTimeSlot
    selectedRange: ProposedTimeSlot
    onClose: () => void
    onSetMeetingTime: (slot: ProposedTimeSlot) => void
}

const TimeSelectModal: React.FC<MeetingTimeSelectionModalProps> = ({
    open,
    selectedRange,
    existingSlot,
    onClose,
    onSetMeetingTime,
}) => {
    const [finalTime, setFinalTime] = useState<ProposedTimeSlot>(selectedRange)

    const maxStartTime = useMemo(() => {
        const maxStartTime = new Date(existingSlot.endTime)
        maxStartTime.setMinutes(maxStartTime.getMinutes() - 30)
        return maxStartTime
    }, [existingSlot])

    const handleStartTimeChange = (value: Date | null) => {
        if (!value) {
            return
        }

        const nextStart = value
        const nextEnd = new Date(value)
        nextEnd.setMinutes(nextEnd.getMinutes() + 30)

        setFinalTime((prev) => ({
            ...prev,
            startTime: nextStart,
            endTime: nextEnd,
        }))
    }

    const handlePrimaryAction = () => {
        onSetMeetingTime(finalTime)
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <Stack padding={2} spacing={2}>
                <Typography variant="h4">
                    {"Schedule Meeting at:"}
                </Typography>

                <DateTimePicker
                    label="Meeting start"
                    value={finalTime.startTime}
                    onChange={handleStartTimeChange}
                    minutesStep={5}
                    minDateTime={selectedRange.startTime}
                    maxDateTime={maxStartTime}
                />

                <Stack direction={"row"} spacing={2}>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={handlePrimaryAction}
                        disabled={!finalTime}
                    >
                        {"Finalise meeting time"}
                    </Button>
                </Stack>
            </Stack>
        </Dialog>
    )
}

export default TimeSelectModal